var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-book-open-page-variant",
      show: _vm.dialog,
      maxWidth: "100%",
      showRequiredFields: false,
      showButton: false,
    },
    on: {
      onSave: _vm.saveAll,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              { attrs: { fluid: "" } },
              [
                _vm.isBlockedByTerms
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          type: "warning",
                          dense: "",
                          outlined: "",
                          icon: "mdi-file-document-alert-outline",
                        },
                      },
                      [
                        _vm._v(
                          " Assine o(s) termo(s) obrigatório(s) pendentes para liberar a edição das marcações. "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.model.info_date
                  ? _c(
                      "v-card",
                      {
                        staticClass: "mb-4 pa-3 grey lighten-5 rounded-lg",
                        attrs: { flat: "" },
                      },
                      [
                        _c(
                          "v-row",
                          { attrs: { align: "start", "no-gutters": "" } },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "pr-md-4 mb-2 mb-md-0",
                                attrs: { cols: "12", md: "5" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-caption grey--text text--darken-2 d-block mb-1",
                                  },
                                  [_vm._v("Período")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "font-weight-medium text-body-2",
                                  },
                                  [_vm._v(_vm._s(_vm.formatPeriod(_vm.model)))]
                                ),
                              ]
                            ),
                            _c("v-col", { attrs: { cols: "12", md: "7" } }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-caption grey--text text--darken-2 d-block mb-1",
                                },
                                [_vm._v("Dias permitidos")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex flex-wrap align-center",
                                  staticStyle: { gap: "6px" },
                                },
                                [
                                  !_vm.hasAllowedDatesList(_vm.model.info_date)
                                    ? [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              color: "grey lighten-3",
                                            },
                                          },
                                          [_vm._v("Todos os dias")]
                                        ),
                                      ]
                                    : [
                                        _vm._l(
                                          _vm.formatAllowedDatesChips(
                                            _vm.model.info_date.allowed_dates
                                          ),
                                          function (d, i) {
                                            return _c(
                                              "v-chip",
                                              {
                                                key: i,
                                                attrs: {
                                                  "x-small": "",
                                                  outlined: "",
                                                  color: "primary",
                                                },
                                              },
                                              [_vm._v(" " + _vm._s(d) + " ")]
                                            )
                                          }
                                        ),
                                        _vm.formatAllowedDatesRemaining(
                                          _vm.model.info_date.allowed_dates
                                        ) > 0
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-caption grey--text",
                                              },
                                              [
                                                _vm._v(
                                                  " +" +
                                                    _vm._s(
                                                      _vm.formatAllowedDatesRemaining(
                                                        _vm.model.info_date
                                                          .allowed_dates
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                ],
                                2
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _vm.loading
                          ? _c("v-progress-linear", {
                              staticClass: "mb-2",
                              attrs: { indeterminate: "", color: "primary" },
                            })
                          : _vm._e(),
                        _vm.renderComponent
                          ? _c("v-data-table", {
                              staticClass: "elevation-1 cartao-ponto-table",
                              attrs: {
                                items: _vm.items,
                                headers: _vm.headers.filter((h) => h.visible),
                                "sort-by": "calories",
                                "item-key": "index",
                                "hide-default-footer": true,
                                "items-per-page": -1,
                                "fixed-header": "",
                                height: "420",
                                dense: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header.check_in_1",
                                    fn: function ({}) {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g(
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [_vm._v("E1")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [_c("span", [_vm._v("Entrada 1")])]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "header.check_out_1",
                                    fn: function ({}) {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g(
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [_vm._v("S1")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [_c("span", [_vm._v("Saída 1")])]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "header.check_in_2",
                                    fn: function ({}) {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g(
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [_vm._v("E2")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [_c("span", [_vm._v("Entrada 2")])]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "header.check_out_2",
                                    fn: function ({}) {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g(
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [_vm._v("S2")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [_c("span", [_vm._v("Saída 2")])]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "header.check_in_3",
                                    fn: function ({}) {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g(
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [_vm._v("E3")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [_c("span", [_vm._v("Entrada 3")])]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "header.check_out_3",
                                    fn: function ({}) {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g(
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [_vm._v("S3")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [_c("span", [_vm._v("Saída 3")])]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "header.check_in_4",
                                    fn: function ({}) {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g(
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [_vm._v("E4")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [_c("span", [_vm._v("Entrada 4")])]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "header.check_out_4",
                                    fn: function ({}) {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g(
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [_vm._v("S4")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [_c("span", [_vm._v("Saída 4")])]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "top",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-center pa-2 flex-wrap",
                                          },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _vm.showAddItem
                                                            ? _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      staticClass:
                                                                        "ma-2",
                                                                      attrs: {
                                                                        color:
                                                                          "primary",
                                                                        disabled:
                                                                          _vm.isBlockedByTerms,
                                                                        depressed:
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.showRegisterOccurrenceItem(
                                                                              {
                                                                                occurrence_sheet_id:
                                                                                  _vm
                                                                                    .model
                                                                                    .id,
                                                                                teacher_id:
                                                                                  _vm
                                                                                    .model
                                                                                    .teacher_id,
                                                                              },
                                                                              -1,
                                                                              1
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    "v-btn",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        left: "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-plus"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    " Adicionar Marcação "
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1225349049
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.isBlockedByTerms
                                                        ? "Assine o(s) termo(s) obrigatório(s) pendentes para liberar a adição"
                                                        : "Adicionar Marcação"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-caption grey--text ml-2",
                                              },
                                              [
                                                _vm._v(
                                                  "Registre os horários de entrada e saída de cada dia"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-chip",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  "x-small": "",
                                                  outlined: "",
                                                  color: "grey",
                                                },
                                              },
                                              [_vm._v("E=Entrada • S=Saída")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "item.date",
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm._f("date")(item.date)) +
                                            " "
                                        ),
                                        _c("br"),
                                        _c("small", {
                                          staticClass: "mt-0 pt-0",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getDescriptionJourney(item)
                                            ),
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.description",
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " + _vm._s(item.description) + " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.check_in_1",
                                    fn: function ({ item }) {
                                      return [
                                        _c("s-text-field", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "00:00",
                                              expression: "'00:00'",
                                            },
                                          ],
                                          attrs: {
                                            clearable: "",
                                            placeholder: "HH:MM",
                                            rules: [_vm.validateTime],
                                            "error-messages":
                                              _vm.errors.check_in_1,
                                            label: "",
                                            disabled: _vm.isItemBlocked(item),
                                          },
                                          model: {
                                            value: item.check_in_1,
                                            callback: function ($$v) {
                                              _vm.$set(item, "check_in_1", $$v)
                                            },
                                            expression: "item.check_in_1",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.check_out_1",
                                    fn: function ({ item }) {
                                      return [
                                        _c("s-text-field", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "00:00",
                                              expression: "'00:00'",
                                            },
                                          ],
                                          attrs: {
                                            clearable: "",
                                            placeholder: "HH:MM",
                                            rules: [_vm.validateTime],
                                            disabled:
                                              _vm.isItemBlocked(item) ||
                                              (!item.check_in_1 &&
                                                !item.check_out_1),
                                            "error-messages":
                                              _vm.errors.check_out_1,
                                            label: "",
                                          },
                                          model: {
                                            value: item.check_out_1,
                                            callback: function ($$v) {
                                              _vm.$set(item, "check_out_1", $$v)
                                            },
                                            expression: "item.check_out_1",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.check_in_2",
                                    fn: function ({ item }) {
                                      return [
                                        _c("s-text-field", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "00:00",
                                              expression: "'00:00'",
                                            },
                                          ],
                                          attrs: {
                                            clearable: "",
                                            placeholder: "HH:MM",
                                            rules: [_vm.validateTime],
                                            disabled:
                                              _vm.isItemBlocked(item) ||
                                              (!item.check_out_1 &&
                                                !item.check_in_2),
                                            "error-messages":
                                              _vm.errors.check_in_2,
                                            label: "",
                                          },
                                          model: {
                                            value: item.check_in_2,
                                            callback: function ($$v) {
                                              _vm.$set(item, "check_in_2", $$v)
                                            },
                                            expression: "item.check_in_2",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.check_out_2",
                                    fn: function ({ item }) {
                                      return [
                                        _c("s-text-field", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "00:00",
                                              expression: "'00:00'",
                                            },
                                          ],
                                          attrs: {
                                            clearable: "",
                                            placeholder: "HH:MM",
                                            rules: [_vm.validateTime],
                                            disabled:
                                              _vm.isItemBlocked(item) ||
                                              (!item.check_in_2 &&
                                                !item.check_out_2),
                                            "error-messages":
                                              _vm.errors.check_out_2,
                                            label: "",
                                          },
                                          model: {
                                            value: item.check_out_2,
                                            callback: function ($$v) {
                                              _vm.$set(item, "check_out_2", $$v)
                                            },
                                            expression: "item.check_out_2",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.check_in_3",
                                    fn: function ({ item }) {
                                      return [
                                        _c("s-text-field", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "00:00",
                                              expression: "'00:00'",
                                            },
                                          ],
                                          attrs: {
                                            clearable: "",
                                            placeholder: "HH:MM",
                                            rules: [_vm.validateTime],
                                            disabled:
                                              _vm.isItemBlocked(item) ||
                                              (!item.check_out_2 &&
                                                !item.check_in_3),
                                            "error-messages":
                                              _vm.errors.check_in_3,
                                            label: "",
                                          },
                                          model: {
                                            value: item.check_in_3,
                                            callback: function ($$v) {
                                              _vm.$set(item, "check_in_3", $$v)
                                            },
                                            expression: "item.check_in_3",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.check_out_3",
                                    fn: function ({ item }) {
                                      return [
                                        _c("s-text-field", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "00:00",
                                              expression: "'00:00'",
                                            },
                                          ],
                                          attrs: {
                                            clearable: "",
                                            placeholder: "HH:MM",
                                            rules: [_vm.validateTime],
                                            disabled:
                                              _vm.isItemBlocked(item) ||
                                              (!item.check_in_3 &&
                                                !item.check_out_3),
                                            "error-messages":
                                              _vm.errors.check_out_3,
                                            label: "",
                                          },
                                          model: {
                                            value: item.check_out_3,
                                            callback: function ($$v) {
                                              _vm.$set(item, "check_out_3", $$v)
                                            },
                                            expression: "item.check_out_3",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.check_in_4",
                                    fn: function ({ item }) {
                                      return [
                                        _c("s-text-field", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "00:00",
                                              expression: "'00:00'",
                                            },
                                          ],
                                          attrs: {
                                            clearable: "",
                                            placeholder: "HH:MM",
                                            rules: [_vm.validateTime],
                                            disabled:
                                              _vm.isItemBlocked(item) ||
                                              (!item.check_out_3 &&
                                                !item.check_in_4),
                                            "error-messages":
                                              _vm.errors.check_in_4,
                                            label: "",
                                          },
                                          model: {
                                            value: item.check_in_4,
                                            callback: function ($$v) {
                                              _vm.$set(item, "check_in_4", $$v)
                                            },
                                            expression: "item.check_in_4",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.check_out_4",
                                    fn: function ({ item }) {
                                      return [
                                        _c("s-text-field", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "00:00",
                                              expression: "'00:00'",
                                            },
                                          ],
                                          attrs: {
                                            clearable: "",
                                            placeholder: "HH:MM",
                                            rules: [_vm.validateTime],
                                            disabled:
                                              _vm.isItemBlocked(item) ||
                                              (!item.check_in_4 &&
                                                !item.check_out_4),
                                            "error-messages":
                                              _vm.errors.check_out_4,
                                            label: "",
                                          },
                                          model: {
                                            value: item.check_out_4,
                                            callback: function ($$v) {
                                              _vm.$set(item, "check_out_4", $$v)
                                            },
                                            expression: "item.check_out_4",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.type",
                                    fn: function ({ item }) {
                                      return [
                                        item.type
                                          ? _c(
                                              "span",
                                              [
                                                item.note || item.motive
                                                  ? _c("emc-info-help", {
                                                      attrs: {
                                                        title: "Justificativa",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "text",
                                                            fn: function () {
                                                              return [
                                                                item.motive
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            item
                                                                              .motive
                                                                              .name
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      item.note
                                                                        ? _c(
                                                                            "small"
                                                                          )
                                                                        : _vm._e(),
                                                                    ])
                                                                  : item.note
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            item.note
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    })
                                                  : _vm._e(),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.type.name) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.actions",
                                    fn: function ({ item, index }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-center justify-center item-actions-row",
                                          },
                                          [
                                            !_vm.hideEdit
                                              ? _c("emc-button-icon", {
                                                  attrs: {
                                                    loading:
                                                      index == _vm.indexItem &&
                                                      _vm.loadingUpdate,
                                                    icon: "mdi-content-save-outline",
                                                    color: "success",
                                                    disabled:
                                                      _vm.disabledActions ||
                                                      _vm.isItemBlocked(item),
                                                    text:
                                                      _vm.isItemBlocked(item) &&
                                                      _vm.isBlockedByTerms
                                                        ? "Assine o(s) termo(s) obrigatório(s) pendentes para liberar a edição"
                                                        : "Salvar Marcações",
                                                    "text-button":
                                                      _vm.showActionText
                                                        ? "Salvar"
                                                        : null,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.updateItem(
                                                        item,
                                                        index
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            !_vm.hideDelete
                                              ? _c("emc-button-icon", {
                                                  attrs: {
                                                    loading:
                                                      index == _vm.indexItem &&
                                                      _vm.loadingDelete,
                                                    icon: "mdi-calendar-plus",
                                                    color: "primary",
                                                    disabled:
                                                      _vm.disabledActions ||
                                                      _vm.isItemBlocked(item),
                                                    text:
                                                      _vm.isItemBlocked(item) &&
                                                      _vm.isBlockedByTerms
                                                        ? "Assine o(s) termo(s) obrigatório(s) pendentes para liberar a edição"
                                                        : "Cadastrar Ocorrência",
                                                    "text-button":
                                                      _vm.showActionText
                                                        ? "Ocorrência"
                                                        : null,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showRegisterOccurrenceItem(
                                                        item,
                                                        index,
                                                        0
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                637238733
                              ),
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-modal", {
              attrs: {
                title: "Justificativa de Alteração",
                icon: "mdi-text-box-edit-outline",
                text: "Informe o motivo da alteração nas marcações de ponto.",
                disabled: _vm.loadingUpdate,
                show: _vm.showJustificationModal,
              },
              on: {
                "update:show": function ($event) {
                  _vm.showJustificationModal = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label:
                                    "Justificativa (Mínimo " +
                                    _vm.minNote +
                                    " caracteres)",
                                  counter: _vm.maxNote,
                                  rules: _vm.justificationRules,
                                  outlined: "",
                                  rows: "3",
                                  "auto-grow": "",
                                  placeholder:
                                    "Informe o motivo da alteração...",
                                },
                                model: {
                                  value: _vm.justificationNote,
                                  callback: function ($$v) {
                                    _vm.justificationNote = $$v
                                  },
                                  expression: "justificationNote",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.cancelJustification()
                            },
                          },
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.loadingUpdate,
                            disabled: !_vm.isJustificationValid,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.confirmJustification()
                            },
                          },
                        },
                        [
                          _vm._v(" Confirmar "),
                          _c("v-icon", { attrs: { right: "", dark: "" } }, [
                            _vm._v("mdi-check"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
            _c("sys-occurrence-teacher-register", {
              attrs: {
                "new-item": _vm.newItem,
                allowedDates: _vm.allowedDates,
                model: _vm.selectedOccurrenceItem,
                show: _vm.showFormRegisterItem,
              },
              on: {
                onCompleted: function ($event) {
                  return _vm.getData()
                },
                "update:show": function ($event) {
                  _vm.showFormRegisterItem = $event
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }